import { SettingsRoutes } from 'pages/settings/route/type'
import { QuestionnaireRoutes } from 'pages/settings/pages/compliance/pages/questionnaire/route/type'
import { BusinessProfileRoutes } from 'pages/settings/pages/compliance/pages/businessProfile/route/type'
import { LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers/route/type'
import {
  TollFreeRoutes,
  TollFreeRoutesSteps,
} from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { CallingRoutesSteps } from 'pages/settings/pages/compliance/pages/calling/route/type'
import { InternationalRoutes } from 'pages/settings/pages/compliance/pages/international/route/type'
import { Upgrade10DLCPackageRoutes } from 'pages/settings/pages/compliance/pages/upgrade10DLCPackage/route/type'
import { ComplianceRoutes } from './type'

const compliance = `${SettingsRoutes.root}/${ComplianceRoutes.root}`

const complianceQuestionnaire = `${compliance}/${QuestionnaireRoutes.root}`

const complianceBusinessProfile = `${compliance}/${BusinessProfileRoutes.root}`
const complianceBusinessProfileCompanyLocation = `${complianceBusinessProfile}/${BusinessProfileRoutes.companyLocation}`

const complianceLocalNumbers = `${compliance}/${LocalNumbersRoutes.root}`
const complianceLocalNumbersUseCases = `${complianceLocalNumbers}/${LocalNumbersRoutes.campaignUseCases}`
const complianceLocalNumbersTollFreeNumbers = `${complianceLocalNumbers}/${LocalNumbersRoutes.tollFreeNumbers}`

const complianceTollFree = `${compliance}/${TollFreeRoutes.root}`
const complianceTollFreeSteps = `${complianceTollFree}/${TollFreeRoutes.steps}`
const complianceTollFreeView = (id: number) => `${complianceTollFree}/${TollFreeRoutes.view}/${id}`
const complianceTollFreeViewSteps = (id: number) =>
  `${complianceTollFree}/${TollFreeRoutes.view}/${id}/${TollFreeRoutes.steps}`
const complianceTollFreeViewUseCaseSteps = (id: number, useCaseNumber: number) =>
  `${complianceTollFree}/${TollFreeRoutes.view}/${id}/use-case-number/${useCaseNumber}/${TollFreeRoutes.steps}`
const complianceTollFreeNumbers = `${compliance}/${TollFreeRoutesSteps.numbers}`
const complianceTollFreeAddNumber = `${complianceTollFree}/${TollFreeRoutes.addNumber}`

const complianceCalling = `${compliance}/${CallingRoutesSteps.root}`
const complianceCallingView = `${complianceCalling}/${CallingRoutesSteps.view}`

const complianceInternational = `${compliance}/${InternationalRoutes.root}`
const complianceInternationalBusinessInfo = `${complianceInternational}/${InternationalRoutes.businessInfo}`
const complianceInternationalBusinessAddress = `${complianceInternational}/${InternationalRoutes.businessAddress}`
const complianceInternationalContactInfo = `${complianceInternational}/${InternationalRoutes.contactInfo}`
const complianceInternationalFinalDetails = `${complianceInternational}/${InternationalRoutes.finalDetails}`

const upgrade10DLCPackageRoot = `/${compliance}/${Upgrade10DLCPackageRoutes.root}`
const upgrade10DLCPackagePackage = upgrade10DLCPackageRoot + `/${Upgrade10DLCPackageRoutes.package}`
const upgrade10DLCPackageSummary = upgrade10DLCPackageRoot + `/${Upgrade10DLCPackageRoutes.summary}`

export const CompliancePath = {
  compliance: {
    root: compliance,
    questionnaire: {
      root: complianceQuestionnaire,
    },
    businessProfile: {
      root: complianceBusinessProfile,
      companyLocation: complianceBusinessProfileCompanyLocation,
    },
    localNumbers: {
      root: complianceLocalNumbers,
      useCases: complianceLocalNumbersUseCases,
      tollFreeNumbers: complianceLocalNumbersTollFreeNumbers,
    },
    tollFree: {
      root: complianceTollFree,
      steps: complianceTollFreeSteps,
      view: (id: number) => complianceTollFreeView(id),
      viewSteps: (id: number) => complianceTollFreeViewSteps(id),
      viewUseCaseSteps: (id: number, useCaseNumber: number) =>
        complianceTollFreeViewUseCaseSteps(id, useCaseNumber),
      numbers: complianceTollFreeNumbers,
      addNumber: complianceTollFreeAddNumber,
    },
    calling: {
      root: complianceCalling,
      view: complianceCallingView,
    },
    international: {
      root: complianceInternational,
      businessInfo: complianceInternationalBusinessInfo,
      businessAddress: complianceInternationalBusinessAddress,
      contactInfo: complianceInternationalContactInfo,
      finalDetails: complianceInternationalFinalDetails,
    },
    upgrade10DLCPackage: {
      root: upgrade10DLCPackageRoot,
      package: upgrade10DLCPackagePackage,
      summary: upgrade10DLCPackageSummary,
    },
  },
}
